import { AccountCircle, Logout, Home } from '@mui/icons-material';
import { 
  Box, 
  AppBar, 
  Toolbar, 
  Typography, 
  Container, 
  IconButton, 
  Menu, 
  MenuItem, 
  Avatar,
  Chip,
  Button,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '../../contexts/AuthContext';
import { ThemeToggle } from '../Theme';

import AdminNavigation from './AdminNavigation';
import MobileAdminNavigation from './MobileAdminNavigation';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    handleClose();
  };

  const handleBackToMain = () => {
    navigate('/');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" elevation={1} sx={{ backgroundColor: theme.palette.error.main, color: theme.palette.primary.contrastText }}>
        <Toolbar>
          {/* 모바일 햄버거 메뉴 */}
          <MobileAdminNavigation />
          
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            StackStock Admin
          </Typography>
          
          {/* 메인으로 돌아가기 버튼 - 데스크톱에서만 표시 */}
          <Button
            color="inherit"
            startIcon={<Home />}
            onClick={handleBackToMain}
            sx={{ 
              mr: 2,
              display: { xs: 'none', md: 'flex' },
            }}
          >
            메인으로
          </Button>
          
          {/* 테마 토글 및 사용자 정보 - 데스크톱에서만 표시 */}
          <Box sx={{ 
            display: { xs: 'none', md: 'flex' }, 
            alignItems: 'center', 
            gap: 1, 
          }}>
            <ThemeToggle />
            <Chip
              avatar={<Avatar sx={{ bgcolor: 'primary.main' }}>
                {(user?.nickname || user?.username)?.charAt(0) || user?.email?.charAt(0) || 'A'}
              </Avatar>}
              label={`관리자: ${user?.nickname || user?.username || user?.email || 'Admin'}`}
              variant="outlined"
              sx={{ 
                color: 'white', 
                borderColor: 'rgba(255, 255, 255, 0.7)',
                '& .MuiChip-avatar': {
                  color: 'white',
                },
              }}
            />
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleLogout}>
                <Logout sx={{ mr: 1 }} />
                로그아웃
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      
      <Container maxWidth="xl" sx={{ flex: 1, py: 3 }}>
        <AdminNavigation />
        <Outlet />
      </Container>
    </Box>
  );
};

export default AdminLayout;